module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/coin_01.png?42e1c886184ea8566facec735c138ab7";